export interface NormalizeOptions {
  trim?: boolean;
  collapseWhitespace?: boolean;
  plusToSpace?: boolean; // set false if you want + to be invalid instead of converted
}

export function normalizeInputValue(
  v: unknown,
  opts: NormalizeOptions = { trim: true, collapseWhitespace: true, plusToSpace: true },
): string {
  let s = typeof v === 'string' ? v : '';
  if (!s) {
    return s;
  }

  if (opts.plusToSpace) {
    s = s.replace(/\+/g, ' ');
  }

  if (opts.collapseWhitespace) {
    s = s.replace(/\s+/g, ' ');
  }

  if (opts.trim) {
    s = s.trim();
  }

  return s;
}
